/**
 * Simple hash function for generating a stable identifier from a value
 * Uses the stringified JSON to create a numeric hash
 */
export const hashValue = (value: any): string => {
  const str = JSON.stringify(value);
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash.toString(36); // Base36 for shorter string
};
